exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1CXOBf4yLXbDsY8dAy3Cx0 {\n  min-height: 185px;\n}\n\np {\n  margin-bottom: 0;\n}\n\n.P7M5iLlAlwqpUWm6WpHdQ {\n  font-weight: bold !important;\n  color: black !important;\n  font-size: 13px !important;\n}\n._1SXQpVkYIAUd_CLj635dv8 {\n  font-weight: normal !important;\n  font-size: 13px !important;\n  color: black !important;\n}\n", ""]);

// exports
exports.locals = {
	"ecgGraph": "_1CXOBf4yLXbDsY8dAy3Cx0",
	"boldCSS": "P7M5iLlAlwqpUWm6WpHdQ",
	"skinyCSS": "_1SXQpVkYIAUd_CLj635dv8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/containers/KardiaRxEcgTable/KardiaRxEcgTable.css
// module id = 8800
// module chunks = 23